import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { ConceptoFacturacion } from '../../_models/concepto-facturacion';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ConceptoFacturacionService } from '../../_services/concepto-facturacion.service';

@Component( {
  selector: 'app-concepto-facturacion-listado',
  templateUrl: 'concepto-facturacion-listado.component.html'
} )

export class ConceptoFacturacionListadoComponent implements OnInit {

  conceptos: ConceptoFacturacion[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor(private conFacturacionServicio: ConceptoFacturacionService,
              private navServicio: NavService,
              private router: Router,
              private autServicio: AutenticacionService) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/concepto-facturacion' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'CONCEPTOS.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'CONCEPTOS.LBL_NOMBRE' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'concepto-facturacion.component' );

    this.conFacturacionServicio.listado().subscribe( conceptos => {
      this.conceptos = conceptos;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear(){
    this.router.navigate(['apl/concepto-facturacion/agregar']);
  }

  ver( concepto: ConceptoFacturacion ) {
    this.router.navigate( [ 'apl/concepto-facturacion/detalle/' + concepto.idConceptoFacturacion ] );
  }

  editar( concepto: ConceptoFacturacion ) {
    this.router.navigate( [ 'apl/concepto-facturacion/actualizar/' + concepto.idConceptoFacturacion ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'concepto-facturacion.component', this.busqueda );
  }
}
